import React from "react";
import { useFormContext } from "react-hook-form";
import { Box, Grid, MenuItem } from "@mui/material";
import FormInput from "@/components/FormInput";
import FormSelect from "@/components/FormSelect";
import TooltipInfoIcon from "@/components/TooltipInfoIcon";
import { usePayeeInformation } from "./hooks/usePayeeInformation";

const PayeeInformationStep = () => {
  const { control } = useFormContext();

  usePayeeInformation();

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} md={12}>
          <FormSelect
            name="payeeType"
            control={control}
            label="Payee Type"
            placeholder="Select payee type"
            controlProps={{ rules: { required: "Required" } }}
            sx={{
              width: "100%",
              "& .MuiButton-root": {
                height: "40px !important",
                minHeight: "40px !important",
              },
            }}
          >
            <MenuItem value="customer">Customer</MenuItem>
            <MenuItem value="contractor">Contractor</MenuItem>
          </FormSelect>
        </Grid>
        <Grid item xs={12} md={12}>
          <FormInput
            name="payeeName"
            control={control}
            label="Payee Name"
            placeholder="Enter payee name"
            controlProps={{ rules: { required: "Required" } }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormInput
            name="payeeAddress"
            control={control}
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                Mailing Address
                <TooltipInfoIcon tooltipText="If mailing address is different from project address, please update below. This address will be used for sending payments and important documents." />
              </Box>
            }
            placeholder="Enter mailing address"
            controlProps={{ rules: { required: "Required" } }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            name="payeeCity"
            control={control}
            label="Mailing City"
            placeholder="Enter mailing city"
            controlProps={{ rules: { required: "Required" } }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            name="payeeState"
            control={control}
            label="Mailing State"
            placeholder="Enter mailing state"
            controlProps={{ rules: { required: "Required" } }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            name="payeeZip"
            control={control}
            label="Mailing Zip Code"
            placeholder="Enter mailing zip"
            controlProps={{ rules: { required: "Required" } }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PayeeInformationStep;
